export default (string) => {
    if (!string.length) {
        return null;
    }

    if (string.includes('(')) {
        return string.replace(/[{()}]/g, '');
    }

    if (string.includes('[')) {
        return string.replace(/[\[\]']+/g,'');
    }
}